import { useRuntimeConfig as useRuntimeConfigFromValtio } from 'vl-common/src/hooks/Runtime';

const getDynamicConfig = async () => {
  const config = window.config;

  if (!config) throw Error('Could not load runtime configuration');
  return Promise.resolve({ config, response: new Response() });
};

function useRuntimeConfig() {
  return useRuntimeConfigFromValtio();
}

function getUpdatedConfig(config: object) {
  return Object.fromEntries(Object.entries(config).map(([key, value]) => [key.toUpperCase(), value]));
}

export default useRuntimeConfig;
export { getDynamicConfig, useRuntimeConfig, getUpdatedConfig };
